const list = resolve => require(['@/components/submitOrder/list'],resolve);
export default [
	{
		path : 'submitOrder/list',
		name : 'submitOrderList',
		meta : {
			title : '必订款',
			mainSearchHandle (){

			},
			notNeedGlobalScroll : true,
			searchDisabled : true
		},
		component : list,
	},
]




// WEBPACK FOOTER //
// ./src/router/submitOrder/index.js